import ServicePageTemplate from '../services/ServicePageTemplate';
import { seoPageData } from '../../mocks/seoPages';
const HvacMaintenancePage = () => <ServicePageTemplate data={seoPageData['hvac-maintenance']} />;
export default HvacMaintenancePage;
